export enum ErrorCodeMainEnum {
	Forbidden = 4030000000,
	Unauthorized = 4010028000,
	Error = 5000000000,
	NotFound = 4040020000,
	Success = 2000000000,
}
